<div class="container ">
    <div style="height: calc(100% - 32px)">
        <router-outlet></router-outlet>
        <div class="container-row">
            <div class="container-column">
                <div class="card-container">
                    <div style="margin-bottom: 15px; height:25px">
                        <kendo-label disabled="projectdisabled" text="Project " [hidden]="!isAdmin || projectdisabled">
                            <kendo-dropdownlist class="dropdown" [formControl]="projectControl" [data]="filteredProjects" textField="projectname"
                                valueField="projectId" [style.width.px]="430" 
                                (valueChange)="getObjectsForProjects($event)" [style.height.%]="100"
                                [disabled]="projectdisabled" [hidden]="!isAdmin || projectdisabled"
                                [filterable]="true"
                                (filterChange)="onProjectFilter($event)"
                                [defaultItem]="defaultItem">
                            </kendo-dropdownlist>
                        </kendo-label>
                    </div>
                    <kendo-tabstrip class="tabstrip" (tabSelect)="onTabSelect($event)" [hidden]="!isAdmin">
                        <kendo-tabstrip-tab class="kendo-tabstrip-m" title="Orders" [selected]="true">
                            <ng-template kendoTabContent>
                                <app-objects [project]="projectSelected">
                                </app-objects>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab class="kendo-tabstrip-m" title="Access" [selected]="false">
                            <ng-template kendoTabContent>
                                <app-access [project]="projectSelected">
                                </app-access>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab class="kendo-tabstrip-m" title="Users" [selected]="false">
                            <ng-template kendoTabContent>
                                <app-users>
                                </app-users>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab class="kendo-tabstrip-m" title="Companies" [selected]="false">
                            <ng-template kendoTabContent>
                                <app-companies>
                                </app-companies>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab class="kendo-tabstrip-m" title="Projects" [selected]="false">
                            <ng-template kendoTabContent>
                                <app-projects> </app-projects>
                            </ng-template>
                        </kendo-tabstrip-tab>

                        <kendo-tabstrip-tab class="kendo-tabstrip-m" title="Portal Log" [selected]="false">
                            <ng-template kendoTabContent>
                                <app-portal-log> </app-portal-log>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab class="kendo-tabstrip-m" title="Import" [selected]="false">
                            <ng-template kendoTabContent>
                                <app-importdata> </app-importdata>
                            </ng-template>
                        </kendo-tabstrip-tab>
                    </kendo-tabstrip>
                </div>
            </div>
        </div>
    </div>